import CompaniesEmployees from './CompaniesEmployees';

export default CompaniesEmployees;
